import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import { GoLinkExternal } from "react-icons/go";
import { X, RefreshCw, MapPin } from "react-feather";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNextToBrands as getNextToBrandsAction, updateBrandMatches as updateBrandMatchesAction, refetch as refetchAction } from "../../../../ReduxToolkit/Reducers/brands";
import { updateRetailerMatches as updateRetailerMatchesAction } from "../../../../ReduxToolkit/Reducers/retailers";
import { toast } from "react-toastify";
import axios from "axios";
import { AI_BACKEND_API_2, HYPERSCOUT_BACKEND_URL } from "../../../../Config/secrets";

import {
  market,
  price,
  product_category,
  style,
  target_group,
} from "../../../../static/brands_wholesalers_data";
import ReactCountryFlag from "react-country-flag";

const ProfileInfoItem = ({
  item,
  navigateToBrand,
  selectedTab,
  isBrand,
  onConvert,
  onWorkingWithClick,
  onDeleteSuccess,
}) => {
  const dispatch = useDispatch();
  const nextToBrandsByKey = useSelector((state) => state?.brands?.nextToBrandsByKey || {});
  const nextToBrandsLoading = useSelector((state) => state?.brands?.nextToBrandsLoading);
  const [isCardHovered, setIsCardHovered] = useState(false);
  const [converting, setConverting] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [gradeDetailsOpen, setGradeDetailsOpen] = useState(false);
  const [deleteNote, setDeleteNote] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [fetchingLocation, setFetchingLocation] = useState(false);
  const [storeLocations, setStoreLocations] = useState(item?.store_locations || []);

  useEffect(() => {
    if (item?.store_locations) {
      setStoreLocations(item?.store_locations);
    }
  }, [item?.store_locations]);

  // const mainAge = item?.main_age;
  const mainCategory = item?.main_category;
  const mainStyle = item?.main_style;
  const mainTargetGroup = item?.main_target_group;

  const { type, id: profileId } = useParams();
  const sortedTargetGroup = [...(item.target_group || [])].sort((a, b) => {
    const aIsMen = a?.toLowerCase() === "men";
    const bIsMen = b?.toLowerCase() === "men";
    return aIsMen === bIsMen ? 0 : aIsMen ? -1 : 1;
  });
  // console.log('item?.store_locations', item?.store_locations)

  // const searchAge = mainAge?.toLowerCase() || item?.age[0]?.toLowerCase();

  // const age_group = age.find((i) => i.label?.toLowerCase() === searchAge);

  const searchCategory =
    mainCategory?.toLowerCase() || item?.product_category[0]?.toLowerCase();
  const searchStyle = mainStyle?.toLowerCase() || item?.style[0]?.toLowerCase();
  const searchTargetGroup =
    mainTargetGroup?.toLowerCase() || sortedTargetGroup[0]?.toLowerCase();

  const category = product_category.find(
    (i) => i.label?.toLowerCase() === searchCategory
  );

  const style_group = style.find((i) => i.label?.toLowerCase() === searchStyle);

  const target = target_group.find(
    (i) => i.label?.toLowerCase() === searchTargetGroup
  );

  // const size_group = size.find(
  //   (i) => i.label?.toLowerCase() === item?.size?.toLowerCase()
  // );
  //  ||
  // size[0];

  // const eco_group = eco_friendly.find(
  //   (i) => i.label?.toLowerCase() === item?.eco_friendly?.toLowerCase()
  // );
  // || eco_friendly[0];

  // || product_category[0];

  const price_group = price.find(
    (i) => i.label?.toLowerCase() === item?.price[0]?.toLowerCase()
  );
  //  || price[0];

  const country = market.find(
    (i) =>
      i.label?.toLowerCase() === item?.country?.toLowerCase()
  );
  // || market[0];

  // const wholesalers =
  //   wholesale_group.find(
  //     (i) =>
  //       i.label?.toLowerCase() === item?.wholesale_group &&
  //       item?.wholesale_group[0]?.toLowerCase()
  //   ) || wholesale_group[0];

  const id_to_redirect = item?.id

  const type_to_redirect = type === "brand"
    ? selectedTab === "Matching"
      ? "wholesaler"
      : (selectedTab === "Matched By AI" || selectedTab === 'Already Working With')
        ? "retailer"
        : "brand"
    : type === "retailer"
      ? "brand"
      : ""

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleting(true);

    const updatePayload = {
      deleted: true,
      ...(deleteNote.trim() && { note: deleteNote.trim() }),
      ...(type === "brand"
        ? { retailer_id: item.id }
        : { brand_id: item.id }),
    };

    const payload = {
      data: {
        updates: [updatePayload],
        ...(type === "brand"
          ? {
            brand_id: Number(profileId),
            matched_by_ai: selectedTab === 'Matched By AI'
          }
          : {
            retailer_id: Number(profileId),
            matched_by_ai: selectedTab === 'Matched By AI'
          }),
      },
      cb: () => {
        setDeleteModalOpen(false);
        setDeleteNote("");
        if (onDeleteSuccess) onDeleteSuccess();
      },
    };

    if (type === "brand") {
      await dispatch(updateBrandMatchesAction(payload));
    } else {
      await dispatch(updateRetailerMatchesAction(payload));
    }

    setDeleting(false);
  };

  const handleRefetch = (e) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch(refetchAction({
      type: item?.type || type_to_redirect,
      ids: [item?.id],
    }));
  };

  const handleFetchLocation = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setFetchingLocation(true);
    try {
      const entityType = item?.type || type_to_redirect;
      const response = await axios({
        method: "POST",
        url: `${AI_BACKEND_API_2}/get_store_location`,
        data: { id: item?.id, type: entityType },
      });

      if (response.data?.status === 200 && response.data?.record) {
        setStoreLocations(response.data.record);
        toast.success(response.data?.msg || "Store locations fetched successfully");
      } else {
        toast.info(response.data?.msg || "No store locations found");
      }
    } catch (err) {
      console.error("Error fetching store locations:", err.message);
      toast.error(err?.response?.data?.msg || err?.message || "Failed to fetch store locations");
    } finally {
      setFetchingLocation(false);
    }
  };

  let parsedMetadata = null;
  if (item?.metadata) {
    try {
      parsedMetadata =
        typeof item.metadata === "string" ? JSON.parse(item.metadata) : item.metadata;
    } catch (error) {
      parsedMetadata = item.metadata;
    }
  }

  const metadataEntries =
    parsedMetadata && typeof parsedMetadata === "object" && !Array.isArray(parsedMetadata)
      ? Object.entries(parsedMetadata)
      : [];

  const nextToBrandIds = Array.isArray(parsedMetadata?.next_to_brands)
    ? parsedMetadata.next_to_brands
      .map((id) => Number(id))
      .filter((id) => Number.isInteger(id) && id > 0)
    : [];
  const nextToBrandsKey = nextToBrandIds.join("-");
  const nextToBrandRecords = nextToBrandsByKey[nextToBrandsKey] || [];

  const formatMetadataValue = (value) => {
    if (Array.isArray(value)) {
      return value.length ? value.join(", ") : "--";
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (value === null || value === undefined || value === "") {
      return "--";
    }

    if (typeof value === "object") {
      return JSON.stringify(value, null, 2);
    }

    return String(value);
  };

  const displayGrade = item?.final_grade || "--";

  const handleOpenGradeDetails = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setGradeDetailsOpen(true);

    if (nextToBrandIds.length && !nextToBrandRecords.length) {
      await dispatch(getNextToBrandsAction(nextToBrandIds));
    }
  };

  return (
    <>
      <Col
        xs={12}
        md={6}
        lg={4}
        className="mb-3 w-100"
        style={{ height: "300px" }}
        onMouseEnter={() => setIsCardHovered(true)}
        onMouseLeave={() => setIsCardHovered(false)}
      >
        <Card
          className="d-flex flex-row h-100 border position-relative"
          style={{
            borderColor: "#CABAAD",
            overflow: "hidden",
          }}
        >
          {/* Delete button - top right corner */}
          {isCardHovered && (selectedTab === "Matched By AI" || selectedTab === "Already Working With") && (
            <button
              onClick={handleDeleteClick}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                zIndex: 10,
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "rgba(220, 53, 69, 0.9)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s ease",
                padding: 0,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(220, 53, 69, 1)";
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(220, 53, 69, 0.9)";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <X size={16} />
            </button>
          )}

          <div
            className="position-relative"
            style={{
              flex: 1,
              backgroundImage: `url(${item?.profile_img ||
                "https://res.cloudinary.com/ramizapp/image/upload/v1733293245/FNAD/z77dbcfjv6g2l7nta7wv.jpg"
                })`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              height: "100%",
              filter: "brightness(0.9)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h4
              className="text-white text-center font-weight-bold"
              style={{
                fontSize: "24px",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 1)",
              }}
            >
              {item?.name}
            </h4>

            {/* Grade + Convert button (Bottom-Left) */}
            <div
              className="position-absolute d-flex align-items-center gap-1"
              style={{ bottom: "10px", left: "10px" }}
            >
              {(item?.final_grade !== undefined || item?.grade !== undefined) && selectedTab !== 'Already Working With' && (
                <div
                  className="d-flex align-items-center gap-1"
                >
                  <button
                    type="button"
                    onClick={handleOpenGradeDetails}
                    style={{
                      background:
                        displayGrade === "A+" ? "linear-gradient(135deg, #0b3d2c 0%, #146c43 100%)"
                          : displayGrade === "A" ? "linear-gradient(135deg, #0a4f8f 0%, #1672c4 100%)"
                            : displayGrade === "B" ? "linear-gradient(135deg, #715400 0%, #b88700 100%)"
                              : displayGrade === "C" ? "linear-gradient(135deg, #8a4b08 0%, #d97706 100%)"
                                : displayGrade === "D" ? "linear-gradient(135deg, #7f1d1d 0%, #dc2626 100%)"
                                  : "rgba(0,0,0,0.8)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "999px",
                      fontSize: "12px",
                      fontWeight: 700,
                      padding: "6px 12px",
                      minHeight: "30px",
                      cursor: "pointer",
                      outline: "none",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                      letterSpacing: "0.02em",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span>Final Grade: {displayGrade}</span>
                    <span style={{ opacity: 0.8, fontWeight: 500 }}>View details</span>
                  </button>
                </div>
              )}

              {item?.type && onConvert && (
                <Button
                  size="md"
                  color={item?.type === "retailer" ? "primary" : "success"}
                  disabled={converting}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setConfirmOpen(true);
                  }}
                  style={{
                    fontSize: "12px",
                    padding: "4px 7px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {converting ? (
                    <Spinner size="sm" style={{ width: "10px", height: "10px" }} />
                  ) : item?.type === "retailer" ? (
                    "Convert to Brand"
                  ) : (
                    "Convert to Retailer"
                  )}
                </Button>
              )}
            </div>

            {(item?.matched_by_ai && !item?.edited) &&
              (selectedTab === "Matched By AI" || selectedTab === "Already Working With") && (
                <div
                  className="position-absolute top-0 start-0 rounded-end py-2 px-4"
                  style={{ backgroundColor: "#0629A5" }}
                >
                  <small className="d-block text-white text-left" style={{ fontSize: '9px' }}>
                    {`Matched By AI`}
                  </small>
                </div>
              )}

            <div className="position-absolute start-0 rounded-end py-2 px-2" style={{ top: 33, backgroundColor: "#f9f9f9" }}>
              <small className="d-block text-black text-left" style={{ fontSize: '9px' }}>
                Working With: {item?.total_working_with_count}
              </small>
            </div>

            {item?.edited && (
              <div
                className="position-absolute top-0 start-0 rounded-end p-2"
                style={{ backgroundColor: "#edd102" }}
              >
                <small className="text-dark" style={{ fontSize: '9px' }}>Added by Hyperscout</small>
              </div>
            )}

            {(!item?.matched_by_ai && !item?.edited) &&
              (selectedTab === "Matched By AI" || selectedTab === "Already Working With") && (
                <div
                  className="position-absolute top-0 start-0 rounded-end p-2"
                  style={{ backgroundColor: "#edd102" }}
                >
                  <small className="text-dark" style={{ fontSize: '9px' }}>Already working</small>
                </div>
              )}
          </div>

          <div
            className="p-2 h-100"
            style={{ flex: 0.7, display: "flex", backgroundColor: "#EFECE9" }}
          >
            <Row className="g-2">
              {/* Target Group */}
              {target ? (
                <Col xs={6} className="text-center">
                  <img
                    src={target?.imageBlack}
                    width="22"
                    height="28"
                    alt="Target"
                  />
                  <small className="d-block" style={{ whiteSpace: 'nowrap' }} >
                    {item?.target_group ? target?.label : "--"}
                  </small>
                </Col>
              ) : item?.eco_friendly ? (
                <Col xs={6} className="text-center">
                  <small className="d-block">--</small>
                </Col>
              ) : (
                <Col xs={6} className="text-center">
                  <Spinner
                    style={{ color: "#000", width: "20px", height: "20px" }}
                  />
                  <small className="d-block">Fetching</small>
                </Col>
              )}

              {/* Product Category */}
              {category ? (
                <Col xs={6} className="text-center">
                  <img
                    src={category?.imageBlack}
                    width="22"
                    height="28"
                    alt="Category"
                  />
                  <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                    {item?.product_category ? category?.label : "--"}
                  </small>
                </Col>
              ) : item?.eco_friendly ? (
                <Col xs={6} className="text-center">
                  <small className="d-block">--</small>
                </Col>
              ) : (
                <Col xs={6} className="text-center">
                  <Spinner
                    style={{ color: "#000", width: "20px", height: "20px" }}
                  />
                  <small className="d-block">Fetching</small>
                </Col>
              )}

              {/* Price Group */}
              {price_group ? (
                <Col xs={6} className="text-center">
                  <img
                    src={price_group.imageBlack}
                    width="22"
                    height="28"
                    alt="Price Group"
                  />
                  <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                    {item?.price ? price_group?.smallLable : "--"}
                  </small>
                </Col>
              ) : item?.eco_friendly ? (
                <Col xs={6} className="text-center">
                  <small className="d-block">--</small>
                </Col>
              ) : (
                <Col xs={6} className="text-center">
                  <Spinner
                    style={{ color: "#000", width: "20px", height: "20px" }}
                  />
                  <small className="d-block">Fetching</small>
                </Col>
              )}

              {style_group ? (
                <Col xs={6} className="text-center">
                  <img
                    src={style_group?.imageBlack}
                    width="22"
                    height="28"
                    alt="Style Group"
                  />
                  <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                    {item?.style ? style_group?.label : "--"}
                  </small>
                </Col>
              ) : item?.eco_friendly ? (
                <Col xs={6} className="text-center">
                  <small className="d-block">--</small>
                </Col>
              ) : (
                <Col xs={6} className="text-center">
                  <Spinner
                    style={{ color: "#000", width: "20px", height: "20px" }}
                  />
                  <small className="d-block">Fetching</small>
                </Col>
              )}

              {country ? (
                <Col xs={6} className="text-center">
                  <ReactCountryFlag
                    countryCode={country?.code}
                    svg
                    style={{
                      width: "25px",
                      height: "25px",
                    }}
                  />
                  <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                    {item?.country ? country?.label : "--"}
                  </small>
                </Col>
              ) : (
                <Col xs={6} className="text-center">
                  <Spinner
                    style={{ color: "#000", width: "20px", height: "20px" }}
                  />
                  <small className="d-block">Fetching</small>
                </Col>
              )}
              <Col xs={6} className="text-center">
                <Link
                  color="link"
                  size="small"
                  className="p-0"
                  target="_blank"
                  to={`/profile/${id_to_redirect}/${type_to_redirect}`}
                >
                  <GoLinkExternal size={22} color="black" />
                  <small className="d-block text-decoration-underline text-black">
                    Profile
                  </small>
                </Link>
              </Col>
              <Col xs={6} className="text-center">
                <button
                  onClick={handleRefetch}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <RefreshCw size={22} color="black" />
                  <small className="d-block text-black">
                    Refetch
                  </small>
                </button>
              </Col>

              {/* Fetch Location button - only shows when store_locations is empty */}
              {(!storeLocations || storeLocations.length === 0) && (
                <Col xs={6} className="text-center">
                  <button
                    onClick={handleFetchLocation}
                    disabled={fetchingLocation}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: fetchingLocation ? "not-allowed" : "pointer",
                      padding: 0,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      opacity: fetchingLocation ? 0.6 : 1,
                    }}
                  >
                    {fetchingLocation ? (
                      <Spinner size="sm" color="primary" style={{ width: "22px", height: "22px" }} />
                    ) : (
                      <MapPin size={22} color="#0d6efd" />
                    )}
                    <small className="d-block" style={{ color: "#0d6efd", fontSize: "11px" }}>
                      Fetch Location
                    </small>
                  </button>
                </Col>
              )}

              {/* Store Locations count badge - shows when locations exist */}
              {storeLocations && storeLocations.length > 0 && (
                <Col xs={6} className="text-center">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#198754",
                        color: "#fff",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {storeLocations.length}
                    </div>
                    <small className="d-block" style={{ color: "#198754", fontSize: "10px" }}>
                      Locations
                    </small>
                  </div>
                </Col>
              )}

              {/* Working With avatars */}
              {item?.working_with?.length > 0 && (
                <Col xs={8} className="mt-1 mx-4">
                  <div className="d-flex align-items-center"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.1)";
                      e.currentTarget.style.zIndex = "10";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.zIndex = 3;
                    }}>
                    {item.working_with.slice(0, 3).map((entry, i) => {
                      const entity = entry.brand || entry.retailer;
                      const initials = entity?.name
                        ? entity.name.slice(0, 2).toUpperCase()
                        : "??";

                      return (
                        <div
                          key={i}
                          title={entity?.name}
                          onClick={() => onWorkingWithClick && onWorkingWithClick(entry, item)}
                          style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "50%",
                            border: "2px solid #fff",
                            marginLeft: i === 0 ? 0 : "-8px",
                            overflow: "hidden",
                            cursor: onWorkingWithClick ? "pointer" : "default",
                            backgroundColor: "#aaa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "9px",
                            fontWeight: "bold",
                            color: "#fff",
                            position: "relative",
                            zIndex: 3 - i,
                            flexShrink: 0,
                            transition: "transform 0.2s ease",
                          }}
                        >
                          {entity?.logo || entity?.profile_img ? (
                            <img
                              src={entity.logo || entity.profile_img}
                              alt={entity?.name}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            initials
                          )}
                        </div>
                      );
                    })}

                    {(item?.total_working_with_count - 3) > 0 && (
                      <small
                        className="text-muted ms-2"
                        style={{ fontSize: "10px", whiteSpace: "nowrap" }}
                      >
                        +{item.total_working_with_count - 3}
                      </small>
                    )}
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Card>
      </Col>

      {/* Convert confirmation modal */}
      {confirmOpen && (
        <Modal
          isOpen={confirmOpen}
          toggle={() => !converting && setConfirmOpen(false)}
          centered
          size="md"
        >
          <ModalHeader
            toggle={() => !converting && setConfirmOpen(false)}
            style={{ borderBottom: "none", paddingBottom: 0 }}
          >
            <span style={{ fontWeight: 700 }}>Confirm Conversion</span>
          </ModalHeader>
          <ModalBody>
            <p className="mb-2">
              You are about to convert{" "}
              <strong>{item?.name}</strong> from a{" "}
              <strong>{item?.type}</strong> to a{" "}
              <strong>
                {item?.type === "retailer" ? "brand" : "retailer"}
              </strong>
              .
            </p>
            <p className="mb-2">This will:</p>
            <ul className="mb-3" style={{ paddingLeft: "1.2rem" }}>
              <li>Remove this {item?.type} from <strong>all existing matches</strong></li>
              <li>Delete the original {item?.type} profile</li>
              <li>
                Create a new{" "}
                {item?.type === "retailer" ? "brand" : "retailer"} profile
              </li>
            </ul>
            <div
              className="d-flex align-items-center gap-2 px-3 py-2 rounded"
              style={{ backgroundColor: "#fff3cd", border: "1px solid #ffc107" }}
            >
              <span style={{ fontSize: "16px" }}>⚠️</span>
              <small style={{ color: "#856404", fontWeight: 500 }}>
                This action <strong>cannot be undone</strong>.
              </small>
            </div>
          </ModalBody>
          <ModalFooter style={{ borderTop: "none", gap: "8px" }}>
            <Button
              color="secondary"
              outline
              size="sm"
              disabled={converting}
              onClick={() => setConfirmOpen(false)}
            >
              Cancel
            </Button>
            <Button
              color={item?.type === "retailer" ? "primary" : "success"}
              size="sm"
              disabled={converting}
              onClick={async () => {
                setConverting(true);
                await onConvert(item);
                setConverting(false);
                setConfirmOpen(false);
              }}
            >
              {converting ? (
                <span className="d-flex align-items-center gap-1">
                  <Spinner size="sm" style={{ width: "12px", height: "12px" }} />
                  Converting…
                </span>
              ) : (
                `Yes, Convert to ${item?.type === "retailer" ? "Brand" : "Retailer"}`
              )}
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* Delete match modal */}
      {deleteModalOpen && (
        <Modal
          isOpen={deleteModalOpen}
          toggle={() => !deleting && setDeleteModalOpen(false)}
          centered
          size="md"
        >
          <ModalHeader
            toggle={() => !deleting && setDeleteModalOpen(false)}
            style={{ borderBottom: "none", paddingBottom: 0 }}
          >
            <span style={{ fontWeight: 700 }}>Remove Match</span>
          </ModalHeader>
          <ModalBody>
            <p className="mb-2">
              Are you sure you want to remove <strong>{item?.name}</strong> from {selectedTab}?
            </p>
            <div className="mt-3">
              <label htmlFor="delete-note" className="form-label" style={{ fontSize: "14px", fontWeight: 500 }}>
                Reason for removal (optional)
              </label>
              <Input
                type="textarea"
                id="delete-note"
                rows={4}
                placeholder="Enter reason for removing this..."
                value={deleteNote}
                onChange={(e) => setDeleteNote(e.target.value)}
                disabled={deleting}
              />
            </div>
          </ModalBody>
          <ModalFooter style={{ borderTop: "none", gap: "8px" }}>
            <Button
              color="secondary"
              outline
              size="sm"
              disabled={deleting}
              onClick={() => {
                setDeleteModalOpen(false);
                setDeleteNote("");
              }}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              size="sm"
              disabled={deleting}
              onClick={handleDeleteConfirm}
            >
              {deleting ? (
                <span className="d-flex align-items-center gap-1">
                  <Spinner size="sm" style={{ width: "12px", height: "12px" }} />
                  Removing…
                </span>
              ) : (
                "Remove Match"
              )}
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {gradeDetailsOpen && (
        <Modal
          isOpen={gradeDetailsOpen}
          toggle={() => setGradeDetailsOpen(false)}
          centered
          size="xl"
        >
          <ModalHeader
            toggle={() => setGradeDetailsOpen(false)}
            style={{ borderBottom: "none", paddingBottom: 0 }}
          >
            <div>
              <div style={{ fontSize: "12px", fontWeight: 600, color: "#8C6A43", textTransform: "uppercase", letterSpacing: "0.08em" }}>
                Match Insights
              </div>
              <div style={{ fontWeight: 700, fontSize: "20px", color: "#1f2937" }}>
                {item?.name}
              </div>
            </div>
          </ModalHeader>
          <ModalBody style={{ paddingTop: "1rem" }}>
            <div
              className="mb-4"
              style={{
                background: "linear-gradient(135deg, #f7f1e8 0%, #ffffff 100%)",
                border: "1px solid #eadfce",
                borderRadius: "16px",
                padding: "18px",
              }}
            >
              <Row className="g-3">
                <Col md={6}>
                  <div
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #ebe4db",
                      borderRadius: "14px",
                      padding: "16px",
                      height: "100%",
                    }}
                  >
                    <div style={{ fontSize: "12px", color: "#8b7355", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "6px" }}>
                      Grade
                    </div>
                    <div style={{ fontSize: "28px", fontWeight: 700, color: "#1f2937" }}>
                      {item?.grade || "--"}
                    </div>
                    <small style={{ color: "#6b7280" }}>
                      Based on a defined Standard / Workflow
                    </small>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    style={{
                      background: "linear-gradient(135deg, #1f2937 0%, #374151 100%)",
                      borderRadius: "14px",
                      padding: "16px",
                      height: "100%",
                      color: "#fff",
                    }}
                  >
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "6px" }}>
                      Final Grade
                    </div>
                    <div style={{ fontSize: "28px", fontWeight: 700 }}>
                      {item?.final_grade || "--"}
                    </div>
                    <small style={{ color: "rgba(255,255,255,0.75)" }}>
                      The final grade is calculated by combining Layer Data and Standard Data.
                    </small>
                  </div>
                </Col>
              </Row>
            </div>

            <div
              style={{
                backgroundColor: "#fbfaf8",
                border: "1px solid #ebe4db",
                borderRadius: "16px",
                padding: "18px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <div style={{ fontWeight: 700, fontSize: "16px", color: "#1f2937" }}>
                    Metadata
                  </div>
                  <small style={{ color: "#6b7280" }}>
                    Signals used to explain the final grade
                  </small>
                </div>
              </div>

              {metadataEntries.length > 0 ? (
                <Row className="g-3">
                  {metadataEntries.map(([key, value]) => (
                    <Col md={6} key={key}>
                      <div
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ece6dd",
                          borderRadius: "12px",
                          padding: "14px",
                          height: "100%",
                        }}
                      >
                        <div style={{ fontSize: "12px", fontWeight: 700, color: "#8b7355", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "8px" }}>
                          {key.replace(/_/g, " ")}
                        </div>
                        {key === "next_to_brands" ? (
                          nextToBrandsLoading && nextToBrandIds.length && !nextToBrandRecords.length ? (
                            <div className="d-flex align-items-center gap-2" style={{ color: "#6b7280" }}>
                              <Spinner size="sm" />
                              <span>Loading related brands...</span>
                            </div>
                          ) : nextToBrandRecords.length ? (
                            <div className="d-flex gap-2" style={{ overflow: 'auto' }}>
                              {nextToBrandRecords.map((brand) => (
                                <div
                                  key={brand.id}
                                  style={{
                                    minWidth: '200px',
                                    border: "1px solid #ece6dd",
                                    borderRadius: "10px",
                                    overflow: 'hidden',
                                    padding: "10px 12px",
                                    backgroundColor: "#fcfbf9",
                                  }}
                                >
                                  <div style={{ fontWeight: 700, color: "#1f2937" }}>
                                    {brand.name || `Brand ${brand.id}`}
                                  </div>
                                  <small style={{ color: "#6b7280" }}>ID: {brand.id}</small>
                                  <div style={{ marginTop: "4px" }}>
                                    <a
                                      href={`/profile/${brand.id}/brand`}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{ color: "#0a4f8f", marginRight: "10px", textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', textDecoration: "underline" }}
                                    >
                                      View Profile
                                    </a>
                                    {brand.website ? (
                                      <a
                                        href={brand.website}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{ color: "#0a4f8f", textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', textDecoration: "underline" }}
                                      >
                                        Website
                                      </a>
                                    ) : (
                                      <small style={{ color: "#6b7280" }}>No website available</small>
                                    )}
                                  </div>
                                </div>
                              ))
                              }
                            </div >
                          ) : (
                            <div
                              style={{
                                color: "#1f2937",
                                fontSize: "14px",
                                lineHeight: 1.5,
                                wordBreak: "break-word",
                              }}
                            >
                              {formatMetadataValue(value)}
                            </div>
                          )
                        ) : (
                          <div
                            style={{
                              color: "#1f2937",
                              fontSize: "14px",
                              lineHeight: 1.5,
                              whiteSpace: typeof value === "object" ? "pre-wrap" : "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {formatMetadataValue(value)}
                          </div>
                        )}
                      </div >
                    </Col >
                  ))}
                </Row >
              ) : (
                <div
                  style={{
                    backgroundColor: "#fff",
                    border: "1px dashed #d7ccbe",
                    borderRadius: "12px",
                    padding: "18px",
                    color: "#6b7280",
                  }}
                >
                  {parsedMetadata ? formatMetadataValue(parsedMetadata) : "No metadata available."}
                </div>
              )}
            </div >
          </ModalBody >
          <ModalFooter style={{ borderTop: "none" }}>
            <Button color="dark" onClick={() => setGradeDetailsOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal >
      )}
    </>
  );
};

export default ProfileInfoItem; 